import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { noop } from 'lodash-es';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const AskInputAttachmentsDisabled = memo(function AskInputAttachmentsDisabled() {
    const { $t } = useIntl();
    return (_jsx(DropdownMenu.Item, { disabled: true, leadingAccessory: $icon('paperclip'), onSelect: noop, subtitle: $t({
            defaultMessage: 'Disabled by your organization',
            description: 'Subtitle explaining that file attachments are disabled by the organization',
            id: 'd3b6c010b1',
        }), children: _jsx(FormattedMessage, { defaultMessage: "Add files or images", description: "Menu item label for adding files or images when attachments are disabled", id: "61c9f36c12" }) }));
});
//# sourceMappingURL=AskInputAttachmentsDisabled.js.map